import { gql } from '@apollo/client';
import { MEETING_FIELDS, RACE_FIELDS, RESULT_FIELDS, ANALYSIS_FIELDS } from '../fragments';

export const GET_MEETINGS = gql`
  ${MEETING_FIELDS}
  ${RACE_FIELDS}
  ${RESULT_FIELDS}
  ${ANALYSIS_FIELDS}
  
  query GetMeetings($date: Date!, $hasTips: Boolean) {
    meetings(date: $date, has_tips: $hasTips) {
      ...MeetingFields
      races {
        ...RaceFields
        results {
          ...ResultFields
        }
        analysis {
          ...AnalysisFields
        }
      }
    }
  }
`;

export const GET_MEETING = gql`
  ${MEETING_FIELDS}
  ${RACE_FIELDS}
  ${RESULT_FIELDS}
  ${ANALYSIS_FIELDS}
  
  query GetMeeting($meetingId: String!, $analysisTypeId: Float = 1) {
    meeting(meeting_id: $meetingId, analysis_type_id: $analysisTypeId) {
      ...MeetingFields
      races {
        ...RaceFields
        results {
          ...ResultFields
        }
        analysis {
          ...AnalysisFields
        }
      }
    }
  }
`;
